const localStoragePrefix = 'storeeel_campaign_click';

export const campaignClickRepository = {
  set(campaignId) {
    const existing = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");

    // CV 判定用のクリックログは期限なしで保持する
    existing[campaignId] = {};

    localStorage.setItem(localStoragePrefix, JSON.stringify(existing));
  },

  getAllValid() {
    const result = {};

    try {
      const data = JSON.parse(localStorage.getItem(localStoragePrefix) || '{}');

      Object.entries(data).forEach(([campaignId, info]) => {
        result[campaignId] = info;
      });

      return result;
    } catch {
      return {};
    }
  },
  removeExpiredCampaigns() {
    // 期限なし運用のため、互換用に残しつつ何もしない
  },
  remove(campaignId) {
    const data = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");

    if (campaignId in data) {
      delete data[campaignId];
      localStorage.setItem(localStoragePrefix, JSON.stringify(data));
    }
  }
};
